import { render, staticRenderFns } from "./ButtonArrow.vue?vue&type=template&id=dd2cd5aa&scoped=true"
import script from "./ButtonArrow.vue?vue&type=script&lang=ts"
export * from "./ButtonArrow.vue?vue&type=script&lang=ts"
import style0 from "./ButtonArrow.vue?vue&type=style&index=0&id=dd2cd5aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2cd5aa",
  null
  
)

export default component.exports